import Base from "@/controllers/base";
export default class VolumeDeviation extends Base {
  static buildLegendList(chart, id) {
    const legendContainer = document.getElementById(id);
    let listContainer = legendContainer.querySelector("ul");

    if (!listContainer) {
      listContainer = document.createElement("ul");
      listContainer.style.display = "flex";
      listContainer.style.flexDirection = "column";
      listContainer.style.margin = 0;
      listContainer.style.padding = 0;
      legendContainer.appendChild(listContainer);
    }

    return listContainer;
  }
  static htmlLegendPlugin() {
    return {
      id: "htmlLegend",
      afterUpdate(chart, args, options) {
        const ul = VolumeDeviation.buildLegendList(chart, options.containerID);
        const parentNode = ul.parentNode;
        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);

        items.forEach((item) => {
          const li = document.createElement("li");
          li.style.alignItems = "center";
          li.style.cursor = "pointer";
          li.style.display = "flex";
          li.style.flexDirection = "row";
          li.style.marginLeft = "2px";

          li.onclick = () => {
            const { type } = chart.config;
            if (type === "pie" || type === "doughnut") {
              // Pie and doughnut charts only have a single dataset and visibility is per item
              chart.toggleDataVisibility(item.index);
            } else {
              chart.setDatasetVisibility(
                item.datasetIndex,
                !chart.isDatasetVisible(item.datasetIndex)
              );
            }
            chart.update();
          };

          // Color box
          const boxSpan = document.createElement("span");
          boxSpan.style.background = item.fillStyle;
          boxSpan.style.borderColor = item.strokeStyle;
          boxSpan.style.borderWidth = item.lineWidth + "px";
          boxSpan.style.display = "inline-block";
          boxSpan.style.flexShrink = 0;
          boxSpan.style.height = "10px";
          boxSpan.style.marginRight = "5px";
          boxSpan.style.width = "20px";

          // Text
          const textContainer = document.createElement("p");
          textContainer.style.color = item.fontColor;
          textContainer.style.margin = 0;
          textContainer.style.padding = 0;
          textContainer.style.textDecoration = item.hidden
            ? "line-through"
            : "";

          const text = document.createTextNode(item.text);
          textContainer.appendChild(text);

          li.appendChild(boxSpan);
          li.appendChild(textContainer);
          ul.appendChild(li);
        });

        if (parentNode.querySelector("a.toggle-all")) return;
        const toggleAll = document.createElement("a");
        toggleAll.innerText = "Show/Hide All";
        toggleAll.setAttribute("class", "toggle-all text-left block");
        toggleAll.setAttribute("data-action", "hide");
        parentNode.insertBefore(toggleAll, ul);
        toggleAll.addEventListener("click", function () {
          var action, hidden;
          action = toggleAll.getAttribute("data-action");
          hidden = action === "hide";
          ul.querySelectorAll("li").forEach(function (li, index) {
            var meta;
            meta = chart.getDatasetMeta(index);
            meta.hidden = hidden;
          });
          chart.update();
          action = action === "hide" ? "show" : "hide";
          return toggleAll.setAttribute("data-action", action);
        });
      },
    };
  }
  static chart(selector, data) {
    var canvas, config, ctx, div, legend;
    div = document.getElementById(selector);
    if (div) {
      div.innerHTML = null;
      div.setAttribute("class", "chart-volume-deviation");
      canvas = document.createElement("canvas");
      canvas.style.width = "80%";
      canvas.style.height = "360px";
      legend = document.createElement("div");
      legend.setAttribute("class", "chart-legend");
      legend.setAttribute("id", `${selector}-legend`);
      div.appendChild(canvas);
      div.appendChild(legend);
      ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      config = {
        type: "bar",
        data: {
          labels: data.labels,
          datasets: data.datasets,
        },
        options: {
          responsive: false,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
          plugins: {
            htmlLegend: {
              containerID: legend.id,
            },
            title: {
              display: true,
              text: data.title,
            },
            legend: {
              display: false,
            },
            tooltip: {
              mode: "nearest",
              intersect: true,
              bodyFont: {
                size: 12,
              },
            },
          },
        },
        plugins: [VolumeDeviation.htmlLegendPlugin()],
      };
      return new Chart(ctx, config);
    }
  }
}
